query Settings($companyId: String) {
  settings(companyId: $companyId) {
    company {
      isPhoneOptional
      enabledPhoneVerification {
        VALUATION
      }
      plotValuation {
        showInPropertyValuation
      }
    }
    lead {
      postalShipping {
        type
        allGuides
        activeLandingpages
      }
    }
  }
}
